<p>{{ 'cookie-policy.handle-text' | translate }} <span [routerLink]="policyPage">{{ 'cookie-policy.handle-action-text' | translate }}</span></p>

<mat-icon (click)="closeBanner()">close</mat-icon>
